export default {
      id: "oc-menu-db-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-menu-db",
      toString: function () {
        return this.url;
      }
    }